import styled from '@emotion/styled'
import type {
  DraggableProvided,
  DraggableStateSnapshot,
} from '@hello-pangea/dnd'
import { Box } from '@mui/material'
import { Component, ReactElement } from 'react'

import { MercurySimpleProductFragment, ProductFragment } from '@/graphql'

interface FacingProps {
  isDragging: boolean
  selected?: boolean
  alwaysShowDropShadow?: boolean
}

const Facing = styled.div<FacingProps>`
  width: 60px;
  height: 60px;
  background: #fff;

  min-width: 60px; /* Add min-width */
  flex-shrink: 0; /* Prevent shrinking */

  border: ${({ selected }) => (selected ? `2px solid #f00` : '1px solid #aaa')};
  border-radius: 8px;
  margin-right: 8px;
  box-shadow: ${({ isDragging, alwaysShowDropShadow }) =>
    isDragging || alwaysShowDropShadow ? `1px 1px 5px #aaa` : 'none'};

  &:focus {
    /* disable standard focus color */
    outline: none;
  }
`

interface Props {
  facing: {
    id: string
    product: ProductFragment | MercurySimpleProductFragment
  }
  provided: DraggableProvided
  snapshot: DraggableStateSnapshot
  onClick?: () => void
  onDoubleClick?: () => void
  onMouseDown?: () => void
  selected?: boolean
  alwaysShowDropShadow?: boolean
}

export default class FacingItem extends Component<Props> {
  render(): ReactElement {
    const facing: {
      id: string
      product: ProductFragment | MercurySimpleProductFragment
    } = this.props.facing
    const provided: DraggableProvided = this.props.provided
    const snapshot: DraggableStateSnapshot = this.props.snapshot
    const alwaysShowDropShadow = this.props.alwaysShowDropShadow

    return (
      <Box sx={{ margin: alwaysShowDropShadow ? '8px' : '0' }}>
        <Facing
          onClick={this.props.onClick}
          onDoubleClick={this.props.onDoubleClick}
          onMouseDown={this.props.onMouseDown}
          ref={ref => provided.innerRef(ref)}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          isDragging={snapshot.isDragging}
          selected={this.props.selected}
          alwaysShowDropShadow={alwaysShowDropShadow}
        >
          <div
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              height: '100%',
              width: '100%',
              overflow: 'hidden',
              padding: '8px',
            }}
          >
            <img
              src={
                facing.product.planogramImageUrl ||
                facing.product.marketingImageUrl ||
                '/static/img/products/unknown-product-planogram-facing.png'
              }
              style={{ height: '100%' }}
            />
          </div>
        </Facing>
      </Box>
    )
  }
}
